<template>
  <div>
    <v-row justify="center">
      <v-dialog
        :value="true"
        persistent
        @click:outside="$emit('close')"
        max-width="550px"
      >
        <v-card>
          <v-card-title>
            <span class="text-subtitle bold pa-4">New User</span>
            <v-spacer></v-spacer>
            <v-icon
              class="mr-2"
              @click="$emit('close')"
            >
              mdi-close
            </v-icon>
          </v-card-title>
          <v-divider
            class="ml-8"
            width="90%"
          ></v-divider>
          <v-form 
            @submit.prevent="addUser"
            v-model="isFormValid"
          >
            <v-card-text>
              <v-container>
                <h4 class="pl-4">PROFILE</h4>
                <v-col>
                  <v-row class="px-7 pt-4">
                    <v-col
                      cols="12"
                      sm="12"
                      md="12"
                    >
                      <label>Username</label>
                      <v-text-field
                        v-model="username"
                        :rules="usernameRules"
                        class="body-2"
                        background-color="#F8F9FB"
                        dense
                        solo
                        flat
                      ></v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                      sm="12"
                      md="12"
                    >
                      <label>Role</label>
                      <v-select
                        v-model="role"
                        class="body-2"
                        :items="this.$store.state.roles"
                        item-text="name"
                        :rules="roleRules"
                        required
                        background-color="#F8F9FB"
                        dense
                        solo
                        flat
                      ></v-select>
                    </v-col>
                  </v-row>
                </v-col>
                <h4 class="pl-4">USER DATA</h4>
                <v-col>
                  <v-row class="px-7 pt-4">
                    <v-col
                      cols="12"
                      sm="12"
                      md="12"
                    >
                      <label>First Name</label>
                      <v-text-field
                        v-model="first_name"
                        class="body-2"
                        :rules="firstnameRules"
                        background-color="#F8F9FB"
                        dense
                        solo
                        flat
                      ></v-text-field>
                    </v-col>                    
                    <v-col
                      cols="12"
                      sm="12"
                      md="12"
                    >
                      <label right>Last Name</label>
                      <v-text-field
                        v-model="last_name"
                        class="body-2"
                        :rules="lastnameRules"
                        background-color="#F8F9FB"
                        dense
                        solo
                        flat
                      ></v-text-field>
                    </v-col>                    
                    <v-col
                      cols="12"
                      sm="12"
                      md="12"
                    >
                      <label>Email</label>
                      <v-text-field
                        type="email"
                        v-model="email"
                        class="body-2"
                        :rules="emailRules"                      
                        required
                        background-color="#F8F9FB"
                        dense
                        solo
                        flat
                      ></v-text-field>
                    </v-col>                    
                    <v-col
                      cols="12"
                      sm="12"
                      md="12"
                    >
                      <label>Company</label>
                      <v-select
                        v-model="company_id"
                        :items="this.$store.state.companies"
                        class="body-2"
                        item-value="id"
                        item-text="name"
                        :rules="companyRules"
                        required
                        background-color="#F8F9FB"
                        dense
                        solo
                        flat
                      ></v-select>
                    </v-col>
                  </v-row>
                </v-col>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                v-if="role === 'affiliation' || role === 'traffic'"
                class="addButton pa-6 mb-6 mr-6 white--text"
                color="btn_secondary"
                @click="dbDialog = true"
                :disabled='!isFormValid'
              >
                Add databases
              </v-btn>
              <v-btn
                v-else
                type="submit"
                class="addButton pa-6 mb-6 mr-6 white--text"
                color="tvf_color"
                :disabled='!isFormValid'
              >
                Save
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="dbDialog"
        :value="true"
        @click:outside="dbDialog = false"
        persistent
        max-width="600px"
      >
        <v-card>
          <v-card-title>
            <span class="text-subtitle bold pa-4">Assign Databases</span>
            <v-spacer></v-spacer>
            <v-icon
              class="mr-2"
              @click="$emit('close')"
            >
              mdi-close
            </v-icon>
          </v-card-title>
          <v-divider class="ml-8" width="90%"></v-divider>
          <v-card-text>
            <br>
            <v-form>
              <v-text-field
                v-model="search"
                class="search-input mx-5 body-2"
                label="Search database"
                prepend-inner-icon="mdi-magnify"
                clearable
                background-color="#F8F9FB"
                dense
                solo
                flat
              ></v-text-field>
            </v-form>        
            <v-container>
              <v-col>
                <v-row class="px-8">
                  <v-col
                    cols="12"
                  >
                    <v-data-table
                      v-model="databasesTable"
                      v-if="!loading"
                      :headers="headers"
                      :items="databases"
                      :item-key="item.id"
                      :search="search"
                    >
                      <LoadingSpinner v-if="!loading" />
                      <template 
                        v-slot:[`item.viewer`]="{ item }"
                      >
                        <v-sheet id="switch">
                          <v-switch
                            v-model="item.use"
                            color="tvf_color"
                            value="viewer"
                            :disabled='item.manager === "manager"'
                          ></v-switch>
                        </v-sheet>
                      </template>
                      <template 
                          v-slot:[`item.manager`]="{ item }"
                      >
                        <v-sheet id="switch">
                          <v-switch
                            v-model="item.use"
                            color="tvf_color"
                            value="manager"
                            :disabled='item.viewer === "viewer"'
                          ></v-switch>
                        </v-sheet>
                      </template>
                    </v-data-table>
                  </v-col>
                </v-row>
              </v-col>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-btn
              type="submit"
              class="addButton pa-6 mb-6 ml-6 white--text caption"
              color="#BDBDBD"
              @click="dbDialog = false"
            >
              <v-icon
                dark
                left
              >
                mdi-arrow-left
              </v-icon>
              Back
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn
              type="submit"
              class="addButton pa-6 mb-6 mr-6 white--text caption"
              color="tvf_color"
              @click="addUser"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </div>
</template>

<script>
import ApiService from "@/services/api.service";

export default {
  data() {
    return {
      role: "",
      username: "",
      email: "",
      first_name: "",
      last_name: "",
      company_id: "",
      errors: [],
      database: [],
      databases: [],
      databasesTable: [],
      item: {},
      use: '',
      search: "",
      loading: false,
      isFormValid: false,
      viewer: false,
      manager: false,
      dbDialog: false,
      headers: [
      {
        text: "NAME",
        align: "start",
        value: "name",
        sorteable: false,          
      },
      {
        text: "VIEWER",
        align: "center",
        value: "viewer",
      },
      { 
        text: "MANAGER", 
        value: "manager", 
        align: "center",
      }],
      usernameRules: [
        v => !!v || 'Username is required',
      ],
      roleRules: [
        v => !!v || 'Role is required',
      ],
      firstnameRules: [
        v => !!v || 'First name is required',
      ],
      lastnameRules: [
        v => !!v || 'Last name is required',
      ],
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) => /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'Invalid Email Address'
      ],
      companyRules: [
        v => !!v || 'Company is required'
      ],
    };
  },

  computed: {
  },

  mounted(item) {
    this.loading = true //the loading begin

    this.$store.commit('getCompanies')
    this.$store.commit('getRoles')
    
    ApiService.get("databases")        
      .then((response) => {
          this.loading = false //the loading stop when the response given from server
          this.databases = response.data.data;

      })
      .catch((error) => {
          this.loading = false
          console.log("Ups! Something is wrong");
      });
  },

  methods: {

    filterOnlyCapsText (value, search) {
    return value != null &&
        search != null &&
        typeof value === 'string' &&
        value.toString().toLocaleLowerCase().indexOf(search) !== -1
    },

    async addUser() {

      this.database = this.databases.filter(item => item.use)
      this.database.forEach((value) => {
        this.databasesTable.push({id: value.id, use: value.use})
      })
            
      await ApiService.post("users", {
        username: this.username,
        first_name: this.first_name,
        last_name: this.last_name,
        email: this.email,
        company_id: this.company_id,
        role: this.role,
        databases: JSON.stringify(this.databasesTable)
      })
        .then((response) => {
          this.$emit('close');
          this.dbDialog = false
          this.$emit('updateList');          
          this.$store.dispatch('setSnackbar', {
            color: 'success',
            text: 'New user has been created!',
            timeout: 3000
          })
        })
        .catch((error) => {
          if (typeof error.response.data === 'object') {
            Object.values(error.response.data.errors).flat().forEach( error => {
              console.log(error)              
              this.$store.dispatch('setSnackbar', {
                color: 'tvf_secondary',
                text: error,
                timeout: 3000
              })       
            })
          }
        });
    },
  }
};
</script>

<style scoped>
.col-sm-4,
.col-md-4,
.col-12,
.col-sm-8,
.col-md-8 {
  padding: 0px;
}

.v-application--is-ltr .v-list-item__icon:first-child {
  margin-right: 0 !important;
}

.v-list-item {
  min-height: 0;
}

.col-sm-4, .col-md-4, .col-12, .col-sm-8, .col-md-8 {
  padding: 0px;
}

.search-input {
    margin: auto;
}

#switch {
    margin: auto;
    width: 55px;
}

.theme--light.v-sheet #switch{
  background-color: rgba(255, 255, 255, 0) !important;
}

</style>